import type { SelectProps } from 'antd';
import { Select } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';

import { FieldValidationMessage } from '../FieldValidationMessage/FieldValidationMessage';

import styles from './Field.module.scss';

interface ISelectProps extends SelectProps {
  fieldName: string;
}

export const SelectField = ({ fieldName, ...restProps }: ISelectProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field, fieldState: { invalid: isInvalid, error } }) => (
        <div className={styles['field-wrapper']}>
          <Select
            {...field}
            {...restProps}
            status={isInvalid ? 'error' : undefined}
          />
          {isInvalid && <FieldValidationMessage message={error?.message} />}
        </div>
      )}
    />
  );
};
